import script from "./CPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPagination.vue?vue&type=script&setup=true&lang=ts"

import "./CPagination.vue?vue&type=style&index=0&id=45ff41c4&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ff41c4"]])

export default __exports__